import getKhattabatAiMessagesStore from "../../../../../stores/khattabat-stores/ai-messages";
import { TSelectionPages } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import InputField from "./InputField";
import SendButton from "./SendButton";

const InputFields = withLiteObserverAndTheme<{ pageType: TSelectionPages }>(
  (props) => {
    const { pageType } = props;
    const shouldShowConversations =
      getKhattabatAiMessagesStore().isOpenedAiMesssagesBox.get();

    return !shouldShowConversations ? null : (
      <ET3Div
        width={1200}
        height={0}
        alignItems={"flex-start"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        {Array.from({ length: 10 }, (_, index) => index).map((index) => {
          return <InputField index={index} />;
        })}
        <SendButton pageType={pageType} />
      </ET3Div>
    );
  }
);

export default InputFields;
